import { orange, blue, red, grey } from '@mui/material/colors/index.js';

// ==================== REGULAR THEMES ====================

export const darkTheme = {
    bg: '#1a1a1a',              
    surface: '#1a1a1a',         
    cardBg: '#2d2d2d',          
    headerBg: '#242424',        
    cardBorder: '#3a3a3a',
    divider: '#3a3a3a',
    accordionBorder: '#3a3a3a',
    accordionBg: '#242424',
    cardHover: '#363636',
    accent: orange[500],        
    accentDark: orange[600],    
    accentLight: orange[400],   
    textPrimary: '#ffffff',
    textSecondary: '#b0b0b0',
    success: orange[500],
    error: red[500],
    shadow: 'rgba(0, 0, 0, 0.3)',
    shadowStrong: 'rgba(0, 0, 0, 0.5)',
    login: {
        bg: '#0a0a0a',
        blur: 'radial-gradient(ellipse at 20% 80%, rgba(255, 140, 0, 0.35) 0%, rgba(255, 140, 0, 0.15) 35%, transparent 45%), radial-gradient(ellipse at 80% 20%, rgba(255, 119, 0, 0.3) 0%, rgba(255, 119, 0, 0.12) 30%, transparent 35%), linear-gradient(160deg, #1a1a1a 0%, #141414 25%, #0d0d0d 50%, #060606 75%, #020202 100%)',
        button: {
            bg: orange[600],
            hover: orange[700],
            shadow: `0 4px 12px ${orange[900]}40`,
        },
        link: {
            text: orange[400],
            hover: orange[300],
        },
        input: {
            bg: 'rgba(255, 255, 255, 0.1)',
            bgHover: 'rgba(255, 255, 255, 0.15)',
            bgFocus: 'rgba(255, 255, 255, 0.1)',
            icon: 'white',
            border: 'rgba(255, 255, 255, 0.3)',
            borderHover: orange[600],
            borderFocus: orange[500],
            label: 'rgba(255, 255, 255, 0.7)',
            text: 'white',
            success: orange[500],
        }
    }
};

export const lightTheme = {
    bg: '#f5f5f5',
    surface: 'rgba(255, 255, 255, 0.95)',
    cardBg: '#ffffff',
    headerBg: 'rgba(0, 0, 0, 0.01)',
    cardBorder: 'rgba(0, 0, 0, 0.08)',
    divider: grey[200],
    cardHover: 'rgba(0, 0, 0, 0.02)',
    accent: blue[600],
    accentDark: blue[700],
    accentLight: blue[50],
    textPrimary: grey[800],
    textSecondary: 'text.secondary',
    success: blue[600],
    error: red[500],
    shadow: 'rgba(0, 0, 0, 0.08)',
    shadowStrong: 'rgba(0, 0, 0, 0.15)',
    login: {
        bg: '#e8eef5',
        blur: 'radial-gradient(ellipse at 20% 80%, rgba(80, 130, 200, 0.55) 0%, rgba(80, 130, 200, 0.2) 40%, transparent 55%), radial-gradient(ellipse at 80% 20%, rgba(220, 95, 0, 0.4) 0%, rgba(220, 95, 0, 0.15) 35%, transparent 45%), linear-gradient(160deg, #f5f7fa 0%, #eef2f7 25%, #e5ecf4 50%, #dce4ef 75%, #d4dde9 100%)',
        button: {
            bg: blue[600],
            hover: blue[700],
            shadow: `0 4px 12px ${blue[900]}30`,
        },
        link: {
            text: blue[500],
            hover: blue[600],
        },
        input: {
            bg: 'rgba(0, 0, 0, 0.04)',
            bgHover: 'rgba(0, 0, 0, 0.06)',
            bgFocus: 'rgba(0, 0, 0, 0.04)',
            icon: 'action.active',
            border: grey[500],
            borderHover: blue[600],
            borderFocus: blue[500],
            label: 'rgba(0, 0, 0, 0.7)',
            text: grey[800],
            success: blue[600],
        }
    }
};

// ==================== CHRISTMAS THEMES ====================

export const darkThemeChristmas = {
    ...darkTheme,
    login: {
        bg: '#050d08',
        blur: 'radial-gradient(ellipse at 20% 80%, rgba(180, 40, 50, 0.35) 0%, rgba(180, 40, 50, 0.15) 35%, transparent 45%), radial-gradient(ellipse at 80% 20%, rgba(30, 80, 50, 0.4) 0%, rgba(30, 80, 50, 0.15) 30%, transparent 40%), linear-gradient(160deg, #0d1f14 0%, #0a1810 25%, #071210 50%, #040a08 75%, #020504 100%)',
        button: {
            bg: orange[600],
            hover: orange[700],
            shadow: `0 4px 12px ${orange[900]}40`,
        },
        link: {
            text: orange[400],
            hover: orange[300],
        },
        input: {
            bg: 'rgba(255, 255, 255, 0.1)',
            bgHover: 'rgba(255, 255, 255, 0.15)',
            bgFocus: 'rgba(255, 255, 255, 0.1)',
            icon: 'white',
            border: 'rgba(255, 255, 255, 0.3)',
            borderHover: orange[600],
            borderFocus: orange[500],
            label: 'rgba(255, 255, 255, 0.7)',
            text: 'white',
            success: orange[500],
        }
    }     
};

export const lightThemeChristmas = {
    ...lightTheme,
    login: {
        bg: '#2a4038',
        blur: 'radial-gradient(ellipse at 20% 80%, rgba(180, 50, 60, 0.5) 0%, rgba(180, 50, 60, 0.25) 40%, transparent 55%), radial-gradient(ellipse at 80% 20%, rgba(40, 120, 70, 0.5) 0%, rgba(40, 120, 70, 0.2) 35%, transparent 50%), linear-gradient(160deg, #3a5048 0%, #304540 25%, #2a4038 50%, #243830 75%, #1e3028 100%)',
        button: {
            bg: '#0e4211ff', 
            hover: '#0b330dff',
            shadow: '0 4px 12px rgba(14, 66, 17, 0.5)',
        },
        link: {
            text: '#0e4211ff',
            hover: '#0e4211ff',
        },
        input: {
            bg: 'rgba(255, 255, 255, 0.25)',
            bgHover: 'rgba(255, 255, 255, 0.27)',
            bgFocus: 'rgba(255, 255, 255, 0.33)',
            icon: `black`,
            border: grey[700],
            borderHover: '#0e4211ff', 
            borderFocus: '#0e4211ff',
            label: '#000000', 
            text: '#000000',
            success: '#0e4211ff',
        }
    }
};
